"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
// hardened external vuex modules
var pkg_frontend_vuex_cabins_1 = require("pkg-frontend-vuex-cabins");
var pkg_frontend_vuex_insurance_1 = require("pkg-frontend-vuex-insurance");
var pkg_frontend_vuex_pax_1 = require("pkg-frontend-vuex-pax");
var pkg_frontend_vuex_persons_1 = require("pkg-frontend-vuex-persons");
var pkg_frontend_vuex_transport_air_1 = require("pkg-frontend-vuex-transport-air");
var pkg_frontend_vuex_transport_flex_flights_1 = require("pkg-frontend-vuex-transport-flex-flights");
var pkg_frontend_vuex_transport_rail_1 = require("pkg-frontend-vuex-transport-rail");
var pkg_frontend_vuex_wizard_1 = require("pkg-frontend-vuex-wizard");
var get_checkin_time_1 = require("./modules/api/get_checkin_time");
var find_stations_1 = require("./modules/api/find_stations");
var ibe_link_1 = require("./modules/api/ibe_link");
var load_transportation_1 = require("./modules/api/load_transportation");
var transport_1 = require("./modules/booking/transport");
var transport_availability_1 = require("./modules/api/transport_availability");
// root Getters (TODO: stab this from the back)
var general_init_book_data_1 = require("./getters/general_init_book_data");
var external_checkout_1 = require("./getters/external_checkout");
var external_general_1 = require("./getters/external_general");
// external actions
var external_checkout_2 = require("./actions/external_checkout");
var external_general_2 = require("./actions/external_general");
// external mutations
var external_general_3 = require("./mutations/external_general");
// actions
var fetch_air_1 = require("./actions/fetch_air");
var fetch_air_flex_1 = require("./actions/fetch_air_flex");
var fetch_insurance_1 = require("./actions/fetch_insurance");
var find_cabin_categories_1 = require("./actions/find_cabin_categories");
var find_cabins_1 = require("./actions/find_cabins");
var find_wish_cabin_1 = require("./actions/find_wish_cabin");
var general_init_1 = require("./actions/general_init");
var handle_price_differ_1 = require("./actions/handle_price_differ");
var refresh_cabins_and_cabin_categories_1 = require("./actions/refresh_cabins_and_cabin_categories");
var reset_stores_1 = require("./actions/reset_stores");
// getters
var insurance_price_1 = require("./getters/insurance_price");
var pax_step_valid_1 = require("./getters/pax_step_valid");
var persons_and_paxes_match_1 = require("./getters/persons_and_paxes_match");
var persons_step_valid_1 = require("./getters/persons_step_valid");
var price_differs_1 = require("./getters/price_differs");
var total_price_1 = require("./getters/total_price");
var MultiCabinsItem = /** @class */ (function () {
    // create everything
    function MultiCabinsItem(namespace) {
        // resolve namespacing, applies "foo/bar/..." stuff automatically
        this.namespaced = true;
        this.actions = __assign(__assign(__assign(__assign(__assign({}, external_checkout_2.default), { fetchAir: fetch_air_1.default,
            fetchAirFlex: fetch_air_flex_1.default,
            fetchInsurance: fetch_insurance_1.default,
            findCabinCategories: find_cabin_categories_1.default,
            findCabins: find_cabins_1.default,
            fetchWishCabin: find_wish_cabin_1.default }), external_general_2.default), general_init_1.default), { handlePriceDiffer: handle_price_differ_1.default,
            refreshCabinsAndCabinCategories: refresh_cabins_and_cabin_categories_1.default,
            resetStores: reset_stores_1.default });
        this.mutations = __assign({}, external_general_3.default);
        this.getters = __assign(__assign(__assign({ apiBookData: general_init_book_data_1.default }, external_checkout_1.default), external_general_1.default), { insurancePrice: insurance_price_1.default,
            paxStepValid: pax_step_valid_1.default,
            personsAndPaxesMatch: persons_and_paxes_match_1.default,
            personsStepValid: persons_step_valid_1.default,
            priceDiffers: price_differs_1.default,
            totalPrice: total_price_1.default });
        this.modules = {
            cabins: new pkg_frontend_vuex_cabins_1.Cabins(),
            insurance: new pkg_frontend_vuex_insurance_1.Insurance(),
            pax: new pkg_frontend_vuex_pax_1.Pax(),
            persons: new pkg_frontend_vuex_persons_1.Persons(),
            transport: new transport_1.Transport(),
            transportAir: new pkg_frontend_vuex_transport_air_1.TransportAir(),
            transportFlexFlights: new pkg_frontend_vuex_transport_flex_flights_1.TransportFlexFlights(),
            transportRail: new pkg_frontend_vuex_transport_rail_1.TransportRail(),
            wizard: new pkg_frontend_vuex_wizard_1.Wizard(),
            // api
            checkinTime: new get_checkin_time_1.CheckinTimeApi(),
            ibeLink: new ibe_link_1.IbeLinkApi(),
            loadTransportation: new load_transportation_1.LoadTransportationApi(),
            stations: new find_stations_1.FindStationsApi(),
            transportAvailability: new transport_availability_1.TransportAvailabilityApi(),
        };
        this.state = new state_1.State();
        var stepList = [
            {
                name: 'bookingPersons',
                // validGetter: namespace+'/persons/isValid',
                validGetter: namespace + '/personsStepValid',
                initHook: function (store) {
                    var personAmount = store.rootGetters[namespace + '/persons/total'];
                    if (personAmount < 1) {
                        store.dispatch(namespace + '/persons/inc', 'adults', { root: true });
                        store.dispatch(namespace + '/persons/inc', 'adults', { root: true });
                    }
                }
            },
            {
                name: 'bookingCabinCategory',
                validGetter: namespace + '/cabins/valid'
            },
            {
                name: 'bookingTransport',
                validGetter: namespace + '/transport/getValid'
            },
            {
                name: 'bookingPax',
                validGetter: namespace + '/paxStepValid' // '/pax/valid'
            },
            {
                name: 'bookingInsurance',
                validGetter: namespace + '/insurance/valid'
            }
        ];
        this.modules.wizard = new pkg_frontend_vuex_wizard_1.Wizard(stepList);
    }
    return MultiCabinsItem;
}());
exports.MultiCabinsItem = MultiCabinsItem;
//# sourceMappingURL=index.js.map